import { isAggregatorUser, notFoundStatus } from "utils/helper";
import store from "../../store";
import {
  SET_ALL_DATES,
  SET_REGISTERED_DATES,
  SET_DASHBOARD_USER_TYPE,
  GET_SUMMARY_CARD_STATS,
  GET_SUMMARY_CARD_STATS_SUCCESS,
  GET_SUMMARY_CARD_STATS_FAIL,
  GET_REGISTERED_AGENTS_STATS_SUCCESS,
  GET_REGISTERED_AGENTS_STATS_FAIL,
  GET_REGISTERED_AGENTS_STATS,
  GET_ENABLED_AGENTS_STATS,
  GET_ENABLED_AGENTS_STATS_SUCCESS,
  GET_ENABLED_AGENTS_STATS_FAIL,
  SET_ENABLED_DATES,
  SET_REG_STATUS_DATES,
  SET_REG_STATUS_REGION,
  GET_AGENTS_PER_REG_STATS,
  GET_AGENTS_PER_REG_STATS_SUCCESS,
  GET_AGENTS_PER_REG_STATS_FAIL,
  SET_RATIO_DATES,
  SET_RATIO_REGION,
  GET_AGENTS_RATIO,
  GET_AGENTS_RATIO_SUCCESS,
  GET_AGENTS_RATIO_FAIL,
  SET_REGION_BREAKDOWN_DATES,
  GET_REGION_BREAKDOWN,
  GET_REGION_BREAKDOWN_SUCCESS,
  GET_REGION_BREAKDOWN_FAIL,
  SET_ADMIN_DATES,
  GET_ADMIN_STATS,
  GET_ADMIN_STATS_SUCCESS,
  GET_ADMIN_STATS_FAIL,
} from "../../types/dashboard/onboardingDashboardTypes";
import { routes } from "routes/apiRoutes";
import makeRequest from "services/makeRequest";
import { formatUrlQuery, isSuccessResponse } from "utils/helper";

const dispatch = store.dispatch;

const getParentId = () => {
  const {
    user: { user },
  } = store.getState();

  return isAggregatorUser(user) ? user?.agent_id : undefined;
};

export const setOnboardingDashboardUserType = (payload) => {
  dispatch({
    type: SET_DASHBOARD_USER_TYPE,
    payload,
  });
};

export const setRegisteredDates = (value, dateType) => {
  dispatch({
    type: SET_REGISTERED_DATES,
    payload: { value, dateType },
  });
};

export const setEnabledDates = (value, dateType) => {
  dispatch({
    type: SET_ENABLED_DATES,
    payload: { value, dateType },
  });
};

export const setRegStatusDates = (value, dateType) => {
  dispatch({
    type: SET_REG_STATUS_DATES,
    payload: { value, dateType },
  });
};

export const setRegStatusRegion = (payload) => {
  dispatch({
    type: SET_REG_STATUS_REGION,
    payload,
  });
};

export const setRatioDates = (value, dateType) => {
  dispatch({
    type: SET_RATIO_DATES,
    payload: { value, dateType },
  });
};

export const setRatioRegions = (payload) => {
  dispatch({
    type: SET_RATIO_REGION,
    payload,
  });
};

export const setRegionBreakDownDates = (value, dateType) => {
  dispatch({
    type: SET_REGION_BREAKDOWN_DATES,
    payload: { value, dateType },
  });
};

export const setAdminDates = (value, dateType) => {
  dispatch({
    type: SET_ADMIN_DATES,
    payload: { value, dateType },
  });
};

export const getOnboardingSummary = async (type, { dateFrom, dateTo }) => {
  const queryParams = {
    parentId: getParentId(),
    type,
    dateFrom,
    dateTo,
  };
  dispatch({ type: GET_SUMMARY_CARD_STATS });
  try {
    const { data } = await makeRequest(
      "get",
      routes.getOnboardingSummary(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_SUMMARY_CARD_STATS_SUCCESS,
        payload: data.data,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_SUMMARY_CARD_STATS_FAIL,
      });
    }

    console.log(error);
  }
};

export const getRegisteredAgentsStats = async (type, { dateFrom, dateTo }) => {
  const queryParams = {
    parentId: getParentId(),
    type,
    dateFrom,
    dateTo,
  };
  dispatch({ type: GET_REGISTERED_AGENTS_STATS });
  try {
    const { data } = await makeRequest(
      "get",
      routes.getRegisteredAgents(formatUrlQuery(queryParams))
    );

    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_REGISTERED_AGENTS_STATS_SUCCESS,
        payload: data.data,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_REGISTERED_AGENTS_STATS_FAIL,
      });
    }

    console.log(error);
  }
};

export const getEnabledAgentsStats = async (type, { dateFrom, dateTo }) => {
  const queryParams = {
    parentId: getParentId(),
    type,
    dateFrom,
    dateTo,
  };
  dispatch({ type: GET_ENABLED_AGENTS_STATS });
  try {
    const { data } = await makeRequest(
      "get",
      routes.getEnabledAgents(formatUrlQuery(queryParams))
    );

    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_ENABLED_AGENTS_STATS_SUCCESS,
        payload: data.data,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_ENABLED_AGENTS_STATS_FAIL,
      });
    }

    console.log(error);
  }
};

export const getRegAgentsStats = async (
  type,
  { dateFrom, dateTo },
  regionCode
) => {
  const queryParams = {
    parentId: getParentId(),
    type,
    dateFrom,
    dateTo,
    region: regionCode,
  };

  dispatch({ type: GET_AGENTS_PER_REG_STATS });
  try {
    const { data } = await makeRequest(
      "get",
      routes.getRegAgentsStats(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_AGENTS_PER_REG_STATS_SUCCESS,
        payload: data.data,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_AGENTS_PER_REG_STATS_FAIL,
      });
    }
    console.log(error);
  }
};

export const getAgentAggregatorRatio = async (
  { dateFrom, dateTo },
  regionCode
) => {
  const queryParams = {
    dateFrom,
    dateTo,
    regionCode,
  };
  dispatch({ type: GET_AGENTS_RATIO });
  try {
    const { data } = await makeRequest(
      "get",
      routes.getAgentAggregatorRatio(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_AGENTS_RATIO_SUCCESS,
        payload: data.data,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_AGENTS_RATIO_FAIL,
      });
    }
    console.log(error);
  }
};

export const getRegionBreakdownStats = async (type, { dateFrom, dateTo }) => {
  const queryParams = {
    type,
    dateFrom,
    dateTo,
  };
  dispatch({ type: GET_REGION_BREAKDOWN });
  try {
    const { data } = await makeRequest(
      "get",
      routes.getRegionBreakdown(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_REGION_BREAKDOWN_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: GET_REGION_BREAKDOWN_FAIL,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_REGION_BREAKDOWN_FAIL,
      });
    }

    console.log(error);
  }
};

export const getAdminStats = async ({ dateFrom, dateTo }) => {
  const queryParams = {
    dateFrom,
    dateTo,
  };
  dispatch({ type: GET_ADMIN_STATS });
  try {
    const { data } = await makeRequest(
      "get",
      routes.getAdminStats(formatUrlQuery(queryParams))
    );
    if (isSuccessResponse(data)) {
      dispatch({
        type: GET_ADMIN_STATS_SUCCESS,
        payload: data.data,
      });
    }
  } catch (error) {
    if (notFoundStatus(error)) {
      dispatch({
        type: GET_ADMIN_STATS_FAIL,
      });
    }

    console.log(error);
  }
};

export const getAllStatistics = ({
  userType,
  dates,
  isAdminUser,
  statusRegions,
  ratioRegions,
}) => {
  dispatch({
    type: SET_ALL_DATES,
    payload: dates,
  });

  getOnboardingSummary(userType, dates);

  if (userType !== "ADMIN") {
    getRegisteredAgentsStats(userType, dates);
    getEnabledAgentsStats(userType, dates);
    getRegAgentsStats(userType, dates, statusRegions);

    if (isAdminUser) {
      getAgentAggregatorRatio(dates, ratioRegions);
      getRegionBreakdownStats(userType, dates);
    }
  } else {
    getAdminStats(dates);
  }
};
